import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Label, Modal } from '@cancercentrum/rcc-bootstrap';
import { useI18n } from '../../i18n';
import { ErrorList } from '../ReviewForm/ErrorList';
export const ValidationModal = (props)=>{
    const { errors, show, onHide } = props;
    const { t } = useI18n();
    const numberOfErrors = errors.filter((x)=>x.$errors.some((y)=>y.isError) || x.$errors.some((y)=>y.name && y.isFatal)).length;
    const numberOfWarnings = errors.filter((x)=>x.$errors.some((y)=>y.isWarning) || x.$errors.some((y)=>y.name && y.isFatal === false)).length;
    return /*#__PURE__*/ _jsxs(Modal, {
        show: show,
        onHide: onHide,
        "data-testid": "ValidationModal",
        bsSize: "xl",
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: t('component.designedform.header')
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: t('component.designedform.p1')
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: t('component.designedform.p2')
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        children: [
                            t('component.designedform.total', numberOfErrors),
                            ' ',
                            /*#__PURE__*/ _jsx(Label, {
                                bsStyle: "danger",
                                children: numberOfErrors
                            }),
                            ' ',
                            t('component.designedform.errors', numberOfErrors),
                            ' ',
                            t('component.designedform.and'),
                            ' ',
                            /*#__PURE__*/ _jsx(Label, {
                                bsStyle: "warning",
                                children: numberOfWarnings
                            }),
                            ' ',
                            t('component.designedform.warnings', numberOfWarnings)
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ErrorList, {
                        errors: errors
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Modal.Footer, {
                children: /*#__PURE__*/ _jsx(Button, {
                    bsStyle: "default-2",
                    onClick: onHide,
                    children: t('button.close')
                })
            })
        ]
    });
};
